import { render, staticRenderFns } from "./traffic-logs.vue?vue&type=template&id=24f5aa2a&"
import script from "./traffic-logs.vue?vue&type=script&lang=js&"
export * from "./traffic-logs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports